import api from "@/api/v1-jwt/config/api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import {
  CreateInvoicePayload,
  CreateInvoiceResponse,
  CreateInvoiceResponseSchema,
} from "../types";
import { createErrorHandler } from "@/utils/errorHandler";

type CreateInvoiceParams = {
  userId: string;
  payload: CreateInvoicePayload;
};

const createInvoice = async ({
  userId,
  payload,
}: CreateInvoiceParams): Promise<CreateInvoiceResponse> => {
  const url = `/platform/invoices/${userId}`;
  const response = await api.post(url, payload);
  return CreateInvoiceResponseSchema.parse(response.data);
};

export const invoiceCreate = {
  createOptions: (
    options?: UseMutationOptions<
      CreateInvoiceResponse,
      Error,
      CreateInvoiceParams
    >
  ) => {
    const defaultOptions: UseMutationOptions<
      CreateInvoiceResponse,
      Error,
      CreateInvoiceParams
    > = {
      mutationFn: createInvoice,
      onError: createErrorHandler({
        customHandlers: {
          400: () => "Invalid invoice data provided",
          403: () => "Unauthorized to create invoice",
          409: (error) => (error.response?.data as any)?.error_message || "Invoice conflict. Please check the values provided.",
        },
      }),
    };
    return { ...defaultOptions, ...options };
  },
  useMutation: (
    options?: UseMutationOptions<
      CreateInvoiceResponse,
      Error,
      CreateInvoiceParams
    >
  ) => {
    const mutationOptions = invoiceCreate.createOptions(options);
    return useMutation<CreateInvoiceResponse, Error, CreateInvoiceParams>(
      mutationOptions
    );
  },
};
